import { Box, Typography, useTheme } from '@mui/material';

import SectionTitle from './components/SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '我要求有限的緊急護理，如此處所述。',

  '我理解DNR意思是如果我的心臟停止跳動或我停止呼吸，將不會實施任何醫療程序來恢復呼吸或心臟功能。',

  '我理解該決定不會阻止我在死亡之前獲得院前急救人員或醫生指導的其他緊急醫療護理。',

  '我理解我可以隨時通過銷毀此表格或明確表示我已改變主意來撤銷此指令。',

  '我允許將此信息提供給醫院、急救人員、醫生、護士或其他衛生人員，以實施此指令。',

  '我在此同意“不施行心肺復甦”指令。',
];

const DNRComponents = (props: Props) => {
  const { disabled } = props;
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="不施行心肺復甦表" />

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 10px auto',
        }}
      >
        {contents.map((v, i) => {
          if (i === 5) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                  color: `${palette.primary.main}`,
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default DNRComponents;
